import {Component} from '@angular/core';
import {MatToolbar} from '@angular/material/toolbar';
import {MatAnchor} from '@angular/material/button';
import {RouterLink} from '@angular/router';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {setCookie} from '../../../utils/helper';

@Component({
  selector: 'app-header',
  imports: [
    MatToolbar,
    RouterLink,
    MatAnchor,
    TranslateModule
  ],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss'
})
export class HeaderComponent {
  constructor(public translate: TranslateService) {
  }

  get lang(): string {
    return this.translate.getCurrentLang() || 'en'
  }

  scrollTo(sectionId: string) {
    if(sectionId === 'home') {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
        const headerOffset = 100;
        const elementPosition = element.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
    }
  }

  switchLang(lang: string) {
    setCookie('appLang', lang, 365);
    this.translate.use(lang);
  }
}
